export default __webpack_public_path__ + "assets/a486e5edf4da09745d0cacc3097102f3/preview.jpg";